import { ElementRef } from '@angular/core';
import { RecorderStore } from '../../../stores/recorder.store';
import { KEYBOARD_ARROW_DOWN_KEY_CODE, KEYBOARD_ARROW_LEFT_KEY_CODE, KEYBOARD_ARROW_RIGHT_KEY_CODE, KEYBOARD_ARROW_UP_KEY_CODE, KEYBOARD_ENTER_KEY_CODE } from '../../../../constants';
import { nearestDividend } from '../../../../shared/helpers/math.helpers';
var TimelineLayerVolumeComponent = /** @class */ (function () {
    function TimelineLayerVolumeComponent(recorderStore) {
        this.recorderStore = recorderStore;
        this.volumeChangeStep = .1;
        this.volume = 1;
    }
    TimelineLayerVolumeComponent.prototype.ngOnInit = function () {
        this.volumeBeforeMute = this.volume;
    };
    Object.defineProperty(TimelineLayerVolumeComponent.prototype, "sliderHandlePosition", {
        get: function () {
            return this.volume * 100;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineLayerVolumeComponent.prototype, "volumeIsHigh", {
        get: function () {
            return this.volume === 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineLayerVolumeComponent.prototype, "volumeIsMedium", {
        get: function () {
            return this.volume < 1 && this.volume >= .5;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineLayerVolumeComponent.prototype, "volumeIsLow", {
        get: function () {
            return this.volume > 0 && this.volume < .5;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimelineLayerVolumeComponent.prototype, "volumeIsMuted", {
        get: function () {
            return this.volume === 0;
        },
        enumerable: true,
        configurable: true
    });
    TimelineLayerVolumeComponent.prototype.onWheel = function (event) {
        event.preventDefault();
        if (event.deltaY > 0) {
            this.decreaseVolume();
        }
        else {
            this.increaseVolume();
        }
    };
    TimelineLayerVolumeComponent.prototype.onHorizontalDragStart = function (event) {
        this.moveToClientX(event.clientX);
    };
    TimelineLayerVolumeComponent.prototype.onHorizontalDrag = function (event) {
        this.moveToClientX(event.clientX);
    };
    TimelineLayerVolumeComponent.prototype.moveToClientX = function (clientX) {
        var track = this.trackElement.nativeElement;
        var trackLeftPadding = parseInt(getComputedStyle(track).paddingLeft.replace('px', ''), 10);
        var trackClientRect = track.getBoundingClientRect();
        var trackClientLeft = trackClientRect.left + trackLeftPadding;
        var trackClientWidth = trackClientRect.width;
        if (clientX < trackClientLeft) {
            this.setVolume(0);
        }
        else if (clientX > trackClientLeft + trackClientWidth) {
            this.setVolume(1);
        }
        else {
            this.setVolume((clientX - trackClientLeft) / trackClientWidth);
        }
    };
    TimelineLayerVolumeComponent.prototype.onIconClick = function () {
        this.muteOrUnmute();
    };
    TimelineLayerVolumeComponent.prototype.muteOrUnmute = function () {
        if (this.volume) {
            this.mute();
        }
        else {
            this.unmute();
        }
    };
    TimelineLayerVolumeComponent.prototype.mute = function () {
        this.volumeBeforeMute = this.volume;
        this.setVolume(0);
    };
    TimelineLayerVolumeComponent.prototype.unmute = function () {
        if (this.volumeBeforeMute) {
            this.setVolume(this.volumeBeforeMute);
        }
        else {
            this.setVolume(1);
        }
    };
    TimelineLayerVolumeComponent.prototype.onKeyDown = function (event) {
        switch (event.keyCode) {
            case KEYBOARD_ARROW_UP_KEY_CODE:
            case KEYBOARD_ARROW_RIGHT_KEY_CODE:
                event.preventDefault();
                this.increaseVolume();
                break;
            case KEYBOARD_ARROW_DOWN_KEY_CODE:
            case KEYBOARD_ARROW_LEFT_KEY_CODE:
                event.preventDefault();
                this.decreaseVolume();
                break;
            case KEYBOARD_ENTER_KEY_CODE:
                event.preventDefault();
                this.muteOrUnmute();
                break;
        }
    };
    TimelineLayerVolumeComponent.prototype.increaseVolume = function () {
        var volume = this.volume + this.volumeChangeStep;
        if (volume > 1) {
            this.setVolume(1);
        }
        else {
            this.setVolume(volume);
        }
    };
    TimelineLayerVolumeComponent.prototype.decreaseVolume = function () {
        var volume = this.volume - this.volumeChangeStep;
        if (volume < 0) {
            this.setVolume(0);
        }
        else {
            this.setVolume(volume);
        }
    };
    TimelineLayerVolumeComponent.prototype.setVolume = function (volume) {
        var layerId = this.layerId;
        volume = nearestDividend(volume, .01);
        this.volume = volume;
        this.recorderStore.setLayerVolume({ layerId: layerId, volume: volume });
    };
    return TimelineLayerVolumeComponent;
}());
export { TimelineLayerVolumeComponent };



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer/timeline-layer-volume/timeline-layer-volume.component.ts.pre-build-optimizer.js